'use client';

import { useSuperstarDetailContext } from './context';
import { TagTeamLinks } from '@wwe-portal/ui/features/roster/tag-team-links';

export const TagTeamLinksConsumer = () => {
  const tagTeamLinks = useSuperstarDetailContext(
    (state) => state.statsSheet.TagTeamLinks
  );

  const tagTeam = tagTeamLinks.map((link) => ({
    id: link.id,
    type: link.Name,
    description: link.Description,
    image: link.logo,
  }));

  if (tagTeam.length === 0) {
    return null;
  }

  return (
    <>
      <div className="drop-shadow-text-2 mb-1 mt-4 text-sm font-bold uppercase italic text-[#00BFFF]">
        Tag Team Links
      </div>
      <TagTeamLinks tagTeam={tagTeam} />
    </>
  );
};
